Currency        = require 'models/currency.coffee'
AccountCategory = require 'models/account_category.coffee'
Account         = require 'models/account.coffee'
Virtual         = require('models/virtual.coffee').Virtual
HM_API          = require 'api.coffee'

store = {}
store.getters =
  default_currency: (state) -> state.user.userdata.default_currency
  first_day_of_week: (state) -> if state.user.userdata.first_day == 0 then 7 else 1
  first_transaction_date: (state) ->
    result = _.minBy(HM.store.state.user.transactions, 'date')?.date || hm_date.constants.today
    return result
  last_transaction_date: (state) ->
    trs = state.user.transactions
    trs[trs.length - 1]?.date || hm_date.constants.today
  forecast: (state) ->
    return 'surplus' if state.ui.forecast.surplus_amount > 0
    return 'neutral' if state.ui.forecast.surplus_amount == 0
    return 'deficit' if state.ui.forecast.surplus_amount < 0
  cache_key: (state) -> state.user.userdata.cache_key
  has_user:  (state) -> !_.isEmpty(state.user.userdata.email)

  user_has_accounts: (_state, getters) -> getters.accounts.length > 0
  user_has_goals: (_state, getters) -> getters.goals.length > 0
  user_has_funds: (_state, getters) -> getters.funds.length > 0
  user_has_transactions: (state) -> state.user.transactions.length > 0

  hidden_tooltips: (state) -> state.user.userdata.bees_viewed

  days_till_end: (state) -> hm_date.differenceInDays(state.user.userdata.paid_till, new Date)
  payment_plan: (state) ->
    if (state.user.userdata.plan == 'russian' || HM.is_russian) then 'ru' else 'en'

  hidden_categories: (state) -> state.user.userdata.settings.hidden_categories || []


store.state =
  ui:
    loaded: false
    forecast:
      surplus_amount: 0
      planning_modal_visible: false
    welcome_modal: false
  user:
    userdata: {}
    accounts: []
    account_categories: []
    virtuals: []
    transactions: []

store.mutations =
  ###*
   * Set user and currencies fields in store
   * @param {Object} payload object with all data
  ###
  'Load User Data': (state, payload) ->
    HM_API.config.headers = _.merge HM_API.config.headers,
      'user-email': payload.user.email
      'user-token': payload.user.authentication_token

    state.user.userdata               = payload.user
    state.user.userdata.settings ||= {}
    state.user.userdata.settings.account_categories ||= {}

    state.user.account_categories     = AccountCategory.all(payload.user.settings.account_categories)
    state.user.accounts               = _.map payload.accounts, (acc) -> new Account(acc)
    state.user.virtuals               = _.map payload.all_virtuals, (vir) -> new Virtual(vir)
    state.user.prices                 = payload.prices
    state.user.intercom_data          = payload.intercom_data
    currencies = _.map payload.currencies, (currency) -> new Currency(currency)
    currencies = currencies.filter (c) -> c.localizedName()
    state.user.currencies = Object.freeze(_.orderBy currencies, (c) -> c.localizedName())
    Currency.all = state.user.currencies

    HM.identify payload.intercom_data
    HM.track 'signed in'

  '💾 USER/HIDE_TOOLTIP': (state, tooltip) ->
    state.user.userdata.bees_viewed.push tooltip

store.actions =
  loginUserFromLocalStorage: (context, payload) ->
    return if context.getters.has_user
    if HM.is_demo
      context.dispatch 'loginUser', {
        form:
          email: 'demo@honeymoney.io'
          password: '111111'
          remember_me: false
      }
    else if localStorage.getItem('email') && localStorage.getItem('authentication_token')
      context.dispatch 'loginUser', {
        form:
          email: localStorage.getItem('email')
          password: 'token'
          remember_me: true
          token: localStorage.getItem('authentication_token')
      }
    else
      HM.router.push { name: 'login_page' }

  ###*
   * Login User
   * we can change for params, and load a demo user, or specific user (for admin), or autologin
   * @param  {Object} payload PAYLOAD_DESCRIPTION
  ###
  loginUser: (context, payload) ->
    loadUser = (response, source) ->
      requestIdleCallback ->
        if source == 'localstorage'
          context.commit 'Load User Data', response
          context.state.ui.loaded = 'localstorage'
          console.time 'Load Transactions from cache'
          localStorage.removeItem('hm_transactions')
          ldb.get 'hm_transactions', (value) ->
            console.timeEnd 'Load Transactions from cache'
            transactions = JSON.parse(value) || []
            if transactions.length
              context.commit('Load Transactions', transactions)
        else
          response.cache_localstorage = true
          context.commit 'Load User Data', response
          context.state.ui.loaded = 'network_user'
          requestIdleCallback -> context.dispatch 'loadTransactions'
          setTimeout (-> context.dispatch('setupPolling')), 1000
        context.dispatch 'redirectUser'

    console.time 'GET_localStorage'
    hm_state = localStorage.getItem('hm_state')
    hm_state = JSON.parse(hm_state)
    console.timeEnd 'GET_localStorage'

    if hm_state
      console.time 'user_data_localstorage'
      loadUser(hm_state, 'localstorage')
      console.timeEnd 'user_data_localstorage'

    console.time 'user_data'
    login_user = HM_API.login_user(payload.form)
    login_user.catch (response) ->
      if response == 'user_not_found'
        turnstile.reset(window.turnstileWidgetId)
        msg = 'Пользователь не найден или неверный пароль' if HM.is_russian
        msg = 'Invalid email or password' if HM.is_english
        f = ->
          context.dispatch 'logoutUser'
          alert(msg)
        setTimeout f, 500
      if response == 'network_error'
        msg = 'Интернет не работает?' if HM.is_russian
        msg = 'Internet is offline?' if HM.is_english
        setTimeout (-> alert(msg)), 100
    login_user.then (response) ->
      console.timeEnd 'user_data'
      loadUser(response, 'network')

  loadTransactions: (context, payload) ->
    console.time 'user_transactions'
    HM_API.load_transactions_json().then (response) ->
      response ||= [] # if user doesn't have any transactions
      context.state.ui.loaded = 'network_transactions'
      response.cache_localstorage = true
      context.commit 'Load Transactions', response
      console.timeEnd 'user_transactions'

  redirectUser: ->
    return unless HM.router.currentRoute.meta.require_auth == false
    HM.router.replace({ path: '/app/mobile/transactions/calendar' }) if HM.is_mobile
    HM.router.replace({ path: '/app/my/transactions/calendar' }) if !HM.is_mobile

  logoutUser: (context) ->
    context.commit 'RESET_STATE'
    localStorage.clear()
    ldb.clear()

    HM.closeAnalytics()
    HM.router.replace { name: 'login_page' }

  hideTooltip: (context, tooltip) ->
    context.commit('💾 USER/HIDE_TOOLTIP', tooltip)
    if !HM.is_demo
      HM_API.update_user {bees_viewed: context.state.user.userdata.bees_viewed}

  showAllTooltips: (context) ->
    context.dispatch('hideTransactionsPopovers')
    context.state.user.userdata.bees_viewed = []
    HM_API.update_user {bees_viewed: context.state.user.userdata.bees_viewed}

  hideAllTooltips: (context) ->
    context.state.user.userdata.bees_viewed = [
      'about_hm_modal', 'categories_editor',
      'tr_form_select_category', 'tr_form_select_description', 'enter_vs_plan', 'tr_form_select_virtual', 'tr_form_select_account', 'tr_form_subtype_select',
      'account_balance', 'account_category', 'account_in_budget', 'account_off_budget', 'account_credit_limit',
      'honeymoney', 'reserves', 'accounts', 'envelopes',
      'envelope_goal', 'envelope_fund', 'envelope_spent',
    ]
    HM_API.update_user {bees_viewed: context.state.user.userdata.bees_viewed}

  showPlanningModal: (context) ->
    context.dispatch('hideTransactionsPopovers')
    context.state.ui.forecast.planning_modal_visible = true

store.mutations['💾 USER/HIDE_CATEGORY'] = (state, category) ->
  hidden_categories = state.user.userdata.settings.hidden_categories || []
  hidden_categories.push category
  Vue.set(state.user.userdata.settings, 'hidden_categories', _.uniq(hidden_categories))
  HM.track 'transaction-hide_category'

store.mutations['💾 USER/SHOW_CATEGORY'] = (state, category) ->
  hidden_categories = state.user.userdata.settings.hidden_categories || []
  _.remove(hidden_categories, (c) => c == category)
  state.user.userdata.settings.hidden_categories = _.clone(hidden_categories)
  HM.track 'transaction-show_category'

store.actions.hideCategory = (context, category) ->
  context.commit('💾 USER/HIDE_CATEGORY', category)
  HM_API.update_user {settings: context.state.user.userdata.settings}

store.actions.showCategory = (context, category) ->
  context.commit('💾 USER/SHOW_CATEGORY', category)
  HM_API.update_user {settings: context.state.user.userdata.settings}

module.exports = store

